import { Application } from '../models/application.model';

export const MOCK_APPLICATIONS: Record<string, Application[]> = {
  'PORTAL-001': [
    {
      applicationId: 'APP-001',
      applicationName: 'Customer Portal Frontend',
      contactEmail: 'unai.manzanoperez.ext@allianz-trade.com',
      emailDistributions: ['frontend-team@allianz-trade.com', 'portal-alerts@allianz-trade.com'],
      features: [
        {
          featureId: 'FEAT-001',
          featureName: 'User Dashboard',
          contactEmail: 'dashboard-team@eulerhermes.com',
          emailDistributions: ['dashboard-alerts@eulerhermes.com']
        },
        {
          featureId: 'FEAT-002',
          featureName: 'Profile Management',
          contactEmail: 'profile-team@allianz.com',
          emailDistributions: ['profile-alerts@allianz.com', 'user-mgmt@allianz.com']
        }
      ]
    },
    {
      applicationId: 'APP-002',
      applicationName: 'Customer Portal Backend',
      contactEmail: 'portal-backend@allianz-trade.com',
      emailDistributions: ['backend-team@allianz-trade.com', 'api-alerts@allianz-trade.com'],
      features: [
        {
          featureId: 'FEAT-003',
          featureName: 'API Gateway',
          contactEmail: 'gateway-team@eulerhermes.com',
          emailDistributions: ['gateway-alerts@eulerhermes.com']
        }
      ]
    }
  ],
  'PAY-001': [
    {
      applicationId: 'APP-003',
      applicationName: 'Payment Processing Service',
      contactEmail: 'payment-processing@eulerhermes.com',
      emailDistributions: ['payment-team@eulerhermes.com', 'finance-alerts@eulerhermes.com', 'security@allianz.com'],
      features: [
        {
          featureId: 'FEAT-004',
          featureName: 'Credit Card Processing',
          contactEmail: 'cc-processing@allianz-trade.com',
          emailDistributions: ['cc-alerts@allianz-trade.com', 'fraud-detection@allianz-trade.com']
        },
        {
          featureId: 'FEAT-005',
          featureName: 'Bank Transfer',
          contactEmail: 'bank-transfer@eulerhermes.com',
          emailDistributions: ['bank-alerts@eulerhermes.com']
        },
        {
          featureId: 'FEAT-006',
          featureName: 'Refund Management',
          contactEmail: 'refund-team@solunion.com',
          emailDistributions: ['refund-alerts@solunion.com']
        }
      ]
    }
  ],
  'USER-001': [
    {
      applicationId: 'APP-004',
      applicationName: 'User Authentication Service',
      contactEmail: 'auth-service@allianz.com',
      emailDistributions: ['auth-team@allianz.com'],
      features: [
        {
          featureId: 'FEAT-007',
          featureName: 'OAuth Integration',
          contactEmail: 'oauth-team@allianz.com',
          emailDistributions: ['oauth-alerts@allianz.com']
        },
        {
          featureId: 'FEAT-008',
          featureName: 'Multi-Factor Authentication',
          contactEmail: 'mfa-team@on-line-services.net',
          emailDistributions: ['mfa-alerts@on-line-services.net', 'security@allianz.com']
        }
      ]
    },
    {
      applicationId: 'APP-005',
      applicationName: 'User Profile Service',
      contactEmail: 'profile-service@allianz-trade.com',
      emailDistributions: ['profile-team@allianz-trade.com', 'user-data@allianz-trade.com'],
      features: []
    }
  ],
  'NOTIF-001': [
    {
      applicationId: 'APP-006',
      applicationName: 'Email Notification Engine',
      contactEmail: 'email-engine@eulerhermes.com',
      emailDistributions: ['email-team@eulerhermes.com', 'smtp-alerts@eulerhermes.com'],
      features: [
        {
          featureId: 'FEAT-009',
          featureName: 'Transactional Emails',
          contactEmail: 'transactional@allianz-trade.com',
          emailDistributions: ['tx-email-alerts@allianz-trade.com']
        },
        {
          featureId: 'FEAT-010',
          featureName: 'Marketing Emails',
          contactEmail: 'marketing@allianz-trade.com',
          emailDistributions: ['marketing-alerts@allianz-trade.com']
        }
      ]
    },
    {
      applicationId: 'APP-007',
      applicationName: 'SMS Notification Service',
      contactEmail: 'sms-service@cpic-eh.com',
      emailDistributions: ['sms-team@cpic-eh.com'],
      features: [
        {
          featureId: 'FEAT-011',
          featureName: 'SMS Gateway',
          contactEmail: 'sms-gateway@cpic-eh.com',
          emailDistributions: ['gateway-alerts@eulerhermes.com']
        }
      ]
    }
  ],
  'AUTH-001': [
    {
      applicationId: 'APP-008',
      applicationName: 'Authentication API',
      contactEmail: 'auth-api@allianz.com',
      emailDistributions: ['auth-dev@allianz.com', 'security@allianz.com'],
      features: [
        {
          featureId: 'FEAT-012',
          featureName: 'JWT Token Service',
          contactEmail: 'jwt-team@allianz.com',
          emailDistributions: ['jwt-alerts@allianz.com']
        },
        {
          featureId: 'FEAT-013',
          featureName: 'Session Management',
          contactEmail: 'session-team@acredia.at',
          emailDistributions: ['session-alerts@acredia.at', 'security@allianz.com']
        }
      ]
    }
  ],
  'ABCD1234': [
    {
      applicationId: 'APP-009',
      applicationName: 'Report Generation Service',
      contactEmail: 'report-gen@allianz-trade.com',
      emailDistributions: ['report-team@allianz-trade.com', 'analytics@allianz-trade.com'],
      features: [
        {
          featureId: 'FEAT-014',
          featureName: 'PDF Report Generator',
          contactEmail: 'pdf-reports@eulerhermes.com',
          emailDistributions: ['pdf-alerts@eulerhermes.com']
        },
        {
          featureId: 'FEAT-015',
          featureName: 'Excel Export',
          contactEmail: 'excel-export@eulerhermes.com',
          emailDistributions: ['excel-alerts@eulerhermes.com']
        }
      ]
    },
    {
      applicationId: 'APP-010',
      applicationName: 'Analytics Dashboard',
      contactEmail: 'analytics-dash@allianz-trade.com',
      emailDistributions: ['dashboard-team@allianz-trade.com', 'bi-alerts@allianz-trade.com'],
      features: [
        {
          featureId: 'FEAT-016',
          featureName: 'Real-time Metrics',
          contactEmail: 'metrics@allianz.com',
          emailDistributions: ['metrics-alerts@allianz.com']
        }
      ]
    }
  ]
};
